import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 投标报价 - 已参与项目 - 竞价采购
 */
export default {
  path: 'compete',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '竞价采购',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
    { companyType: companyTypeDict.SELF_EMPLOYEE.value },
    { companyType: companyTypeDict.PERSON.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
  roles: [
    platformFunctionModuleDict.SUPPLIER.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 项目列表
    {
      path: 'list',
      name: 'ParticipateCompete',
      component: '/supplier-views/participate/compete',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '项目列表',
        cache: true,
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 项目详情
    {
      path: 'order/:orderId/detail',
      name: 'SupplierCompeteDetail',
      component: '/supplier-views/compete/compete-detail',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '项目详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 项目报名
    {
      path: 'order/:orderId/sign-up/trade/:tradeId?',
      name: 'SupplierCompeteSignUp',
      component: '/supplier-views/compete/sign-up/index',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '项目报名',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 变更公告
    {
      path: 'order/:orderId/change-ann',
      name: 'SupplierCompeteChangeAnn',
      component: '/supplier-views/compete/change-ann',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '变更公告',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 竞价大厅
    {
      path: 'order/:orderId/compete-hall/:token',
      name: 'SupplierCompeteHall',
      component: '/supplier-views/compete/compete-hall',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '竞价大厅',
        hidden: true,
        layout: 'NoLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    }
  ]
}
